import React, { Component } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { connect } from "react-redux";
import { SwipeableDrawer } from "@material-ui/core";
import DeliveryTimeChange from "./DeliveryTimeChange";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import GiftForm from "./GiftForm";
import CardGiftcardOutlinedIcon from "@material-ui/icons/CardGiftcardOutlined";
import { isValidPhoneNumber } from "react-phone-number-input";

const isVirginPhoneNumber = (phone) => {
  // For Virgin Mobile Kuwait. Numbers are 8 digits long and start with 41
  if (!phone) return false;
  if (
    phone.startsWith("+965") &&
    phone.split("+965")[1].startsWith("41") &&
    phone.split("+965")[1].length === 8
  )
    return true;
  return false;
};
class Gift extends Component {
  state = {
    drawerOpen: false,
    Switch: false,
    name: this.props.name,
    message: this.props.message,
    gift_recipient_number: this.props.gift_recipient_number,
    gift_link: this.props.gift_link,
    unknownLocation: this.props.unknown_location,
    errorName: this.props.errorName,
    errorNumber: this.props.errorNumber,
    giftAnonymousCheck: this.props.send_gift_anonymously,
    call_recipient_check: this.props.call_recipient,
    gift_wrapping: this.props.gift_wrapping,
  };
  toggleDrawer = (open) => {
    this.setState({ drawerOpen: open });
    if (
      this.props.urlPathname === "/checkout/address" ||
      this.props.urlPathname === "/checkout/address/"
    ) {
      this.props.closeGiftDrawer(false);
    }
  };

  handleChange = (e, eventPhone) => {
    let newState = { ...this.state };
    let errorNumber = false;
    let phoneNumber = "";
    if (typeof e == "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        phoneNumber = e.replace(
          "+" + eventPhone.dialCode,
          `+${eventPhone.dialCode}-`
        );

        this.setState({ gift_recipient_number: phoneNumber });
        newState.gift_recipient_number = phoneNumber;
      }

      if (
        isValidPhoneNumber(phoneNumber.replace("-", "")) ||
        isVirginPhoneNumber(phoneNumber.replace("-", ""))
      ) {
        errorNumber = false;
        this.setState({ errorNumber: false });
      } else {
        errorNumber = true;
        this.setState({ errorNumber: true });
      }
    } else {
      this.setState({ [e.target.name]: e.target.value });
      newState[e.target.name] = e.target.value;
      if (this.props.settings.enable_force_gift_name_number) {
        if (e.target.name === "name") {
          this.setState({ errorName: false });
        }
      }
    }
    if (this.props.settings.enable_force_gift_name_number) {
      this.props.handleErrorChange("name", this.state.name ? false : true);
      if (eventPhone) {
        this.props.handleErrorChange("number", errorNumber);
      }
    }
    this.props.SetGiftMsg(
      newState.name,
      newState.message,
      newState.gift_recipient_number,
      newState.gift_link,
      newState.giftAnonymousCheck,
      newState.call_recipient_check,
      newState.gift_wrapping
    );
  };

  handleAddressForUnknownLocation = (value) => {
    if (this.props.settings.enable_unknown_gift_recipient_location) {
      this.props.setGiftUnknownLocation(value);
      if (
        this.props.unknown_location &&
        this.props.address.selectedDeliveryType === 0
      ) {
        if (
          this.props.urlPathname === "/checkout/address" ||
          this.props.urlPathname === "/checkout/address/"
        ) {
          this.props.resetAddressForUnknownLocation();
        }
        this.props.resetAddress();
      }
    }
  };

  toggleSwitch = (e) => {
    const checked = e.target.checked;

    this.setState({ Switch: checked });
    this.props.SetGift(checked);
    if (
      checked === false &&
      this.props.settings.enable_unknown_gift_recipient_location
    ) {
      this.handleAddressForUnknownLocation(false);
    }
  };

  toggleGiftAnonymous = (e) => {
    const checked = e.target.checked;
    this.setState({ giftAnonymousCheck: checked });
    this.props.SetGiftMsg(
      this.state.name,
      this.state.message,
      this.state.gift_recipient_number,
      this.state.gift_link,
      checked,
      this.state.call_recipient_check,
      this.state.gift_wrapping
    );
  };

  toggleCallRecipient = (e) => {
    const checked = e.target.checked;
    this.setState({ call_recipient_check: checked });
    this.props.SetGiftMsg(
      this.state.name,
      this.state.message,
      this.state.gift_recipient_number,
      this.state.gift_link,
      this.state.giftAnonymousCheck,
      checked,
      this.state.gift_wrapping
    );
  };
  toggleGiftWrapping = (e) => {
    const checked = e.target.checked;
    this.setState({ gift_wrapping: checked });
    this.props.SetGiftMsg(
      this.state.name,
      this.state.message,
      this.state.gift_recipient_number,
      this.state.gift_link,
      this.state.giftAnonymousCheck,
      this.state.call_recipient_check,
      checked
    );
  };

  componentDidMount = () => {
    const { promise } = this.props;
    if (
      promise.isGift &&
      !promise.gift_name &&
      !promise.gift_recipient_number &&
      !promise.gift_message
    ) {
      this.props.enableIsGift(false);
    }
  };

  clearGift = () => {
    this.setState({
      name: "",
      message: "",
      gift_recipient_number: "",
      gift_link: "",
      errorName: false,
      errorNumber: false,
      drawerOpen: false,
    });
    this.props.SetGiftMsg("", "", "", "", false, false);

    this.handleAddressForUnknownLocation(false);
    this.props.SetGift(false);
    this.setState({ Switch: false });
    if (
      this.props.urlPathname === "/checkout/address" ||
      this.props.urlPathname === "/checkout/address/"
    ) {
      this.props.closeGiftDrawer(false);
    }
  };
  render() {
    const { language, promise, themeColor } = this.props;
    return (
      <>
        <div style={{ marginTop: 30 }}>
          <div
            style={{
              display: this.props.settings.enable_gift_form_open ? "flex" : "",
              justifyContent: this.props.settings.enable_gift_form_open
                ? "space-between"
                : "",
              alignItems: this.props.settings.enable_gift_form_open
                ? "center"
                : "",
            }}
          >
            <p
              className="box-title"
              style={{
                textAlign: language === "arabic" ? "right" : "left",
                margin: this.props.settings.enable_gift_form_open ? 0 : "",
              }}
            >
              {language == "english" ? "Gift" : "هدية"}
            </p>
            {this.props.settings.enable_gift_form_open && (
              <div>
                <Switch
                  checked={promise.isGift}
                  onChange={(e) => {
                    this.props.SetGift(e.target.checked);
                    this.setState({ Switch: e.target.checked });
                  }}
                  color="primary"
                />
              </div>
            )}
          </div>
          <div
            className="bordered row w-100 mx-0 justify-content-between"
            style={{ backgroundColor: "white", minHeight: 60 }}
            dir={language == "english" ? "ltr" : "rtl"}
            onClick={(e) => {
              if (
                this.props.promise.isGift &&
                e.target.tagName !== "INPUT" &&
                !this.props.settings.enable_gift_form_open
              ) {
                this.toggleDrawer(true);
              }
            }}
          >
            {this.props.settings.enable_gift_form_open ? (
              <GiftForm
                handleChange={(e) => {
                  this.setState({ [e.target.name]: e.target.value });
                  if (this.props.settings.enable_force_gift_name_number) {
                    if (e.target.name === "name") {
                      this.props.handleErrorChange("name", false);
                    }
                    if (e.target.name === "gift_recipient_number") {
                      this.props.handleErrorChange("number", false);
                    }
                  }
                  this.props.SetGiftMsg(
                    this.state.name,
                    this.state.message,
                    this.state.gift_recipient_number,
                    this.state.gift_link,
                    this.state.giftAnonymousCheck,
                    this.state.call_recipient_check,
                    this.state.gift_wrapping
                  );
                }}
                errorName={this.props.errorName}
                errorNumber={this.props.errorNumber}
                name={this.props.name}
                message={this.props.message}
                gift_recipient_number={this.props.gift_recipient_number}
                gift_link={this.props.gift_link}
                giftAnonymousCheck={this.state.giftAnonymousCheck}
                gift_wrapping={this.state.gift_wrapping}
                unknownLocation={this.state.unknownLocation}
                toggleGiftAnonymous={this.toggleGiftAnonymous}
                toggleGiftWrapping={this.toggleGiftWrapping}
              />
            ) : (
              <>
                <div
                  className={"col-8 align-self-center ml-0 ".concat(
                    language == "english" ? "text-left pl-0" : "text-right pr-0"
                  )}
                  style={{
                    fontSize: "1rem",
                    fontWeight: 400,
                    paddingTop: 15,
                    paddingBottom: 15,
                  }}
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "50px auto",
                      alignItems: "center",
                    }}
                  >
                    <div className="text-center">
                      <CardGiftcardOutlinedIcon style={{ color: "#5b5b5b" }} />
                    </div>
                    <span>
                      {language === "english"
                        ? "Is this a gift?"
                        : "هل هذا الطلب هدية؟"}
                    </span>
                  </div>

                  {promise.isGift &&
                    (this.props.urlPathname !== "/checkout/address" ||
                      this.props.urlPathname === "/checkout/address/") &&
                    (promise.gift_name ||
                      promise.gift_recipient_number ||
                      promise.gift_message ||
                      promise.gift_link) && (
                      <div
                        className={"mt-2 ".concat(
                          language == "english" ? "ml-2" : "mr-2"
                        )}
                        style={{
                          paddingTop: 5,
                          paddingBottom: 5,
                          [`padding${
                            language === "arabic" ? "Right" : "Left"
                          }`]: 15,
                        }}
                      >
                        {promise.gift_name && (
                          <p
                            className="m-0"
                            style={{
                              fontSize: "0.85rem",
                              color: "#999",
                              fontWeight: "bold",
                            }}
                          >
                            <span>
                              {language == "english" ? "Name:" : "الاسم:"}
                            </span>{" "}
                            {promise.gift_name}
                          </p>
                        )}

                        {promise.gift_recipient_number && (
                          <p
                            className="m-0"
                            style={{
                              fontSize: "0.85rem",
                              color: "#999",
                              fontWeight: "bold",
                            }}
                          >
                            <span>
                              {language == "english" ? "Number:" : "الرقم:"}
                            </span>{" "}
                            {promise.gift_recipient_number}
                          </p>
                        )}

                        {promise.gift_message && (
                          <p
                            className="m-0"
                            style={{
                              fontSize: "0.85rem",
                              color: "#999",
                              fontWeight: "bold",
                            }}
                          >
                            <span>
                              {language == "english" ? "Message:" : "الرسالة:"}
                            </span>{" "}
                            {promise.gift_message}
                          </p>
                        )}

                        {promise.gift_link && (
                          <p
                            className="m-0"
                            style={{
                              fontSize: "0.85rem",
                              color: "#999",
                              fontWeight: "bold",
                            }}
                          >
                            <span>
                              {language == "english" ? "Link:" : "الرسالة:"}
                            </span>{" "}
                            {promise.gift_link}
                          </p>
                        )}
                        {promise.send_gift_anonymously &&
                          this.props.settings.enable_send_gift_anonymously &&
                          this.props.settings
                            .enable_send_gift_anonymously_staff && (
                            <p
                              className="m-0"
                              style={{
                                fontSize: "0.85rem",
                                color: "#999",
                                fontWeight: "bold",
                              }}
                            >
                              <span>
                                {language === "english"
                                  ? "Gift will be sent anonymously"
                                  : "الهدية سترسل بشكل مجهول"}
                              </span>{" "}
                            </p>
                          )}
                        {promise.call_recipient && (
                          <p
                            className="m-0"
                            style={{
                              fontSize: "0.85rem",
                              color: "#999",
                              fontWeight: "bold",
                            }}
                          >
                            <span>
                              {language === "english"
                                ? "Call recipient on arrival"
                                : "عند الوصول سيتم التواصل مع المستلم"}
                            </span>{" "}
                          </p>
                        )}
                        {promise.gift_wrapping && (
                          <p
                            className="m-0"
                            style={{
                              fontSize: "0.85rem",
                              color: "#999",
                              fontWeight: "bold",
                            }}
                          >
                            <span>
                              {language === "english"
                                ? "Gift wrapping added"
                                : "تمت إضافة تغليف الهدايا"}
                            </span>{" "}
                          </p>
                        )}

                        {promise.gift_name ||
                        promise.gift_message ||
                        promise.gift_recipient_number ||
                        promise.gift_link ? (
                          <p
                            className="m-0 mt-2"
                            style={{
                              fontSize: "0.9rem",
                              color: "#999",
                              fontWeight: "bold",
                              color: themeColor,
                            }}
                            onClick={() => {
                              this.setState({ drawerOpen: true });
                            }}
                          >
                            {language == "english"
                              ? "Tap to edit"
                              : "اضغط للتعديل"}
                          </p>
                        ) : null}
                      </div>
                    )}
                </div>
                <div
                  className={"col-2 align-self-center mr-4 pr-0 ".concat(
                    language == "english" ? "text-right" : "text-left"
                  )}
                >
                  <Switch
                    checked={promise.isGift}
                    onChange={this.toggleSwitch}
                    color="primary"
                  />
                </div>
              </>
            )}
          </div>
          {(this.state.Switch || this.state.drawerOpen) && (
            <div className="h-100">
              <GiftForm
                closeDrawer={() => {
                  if (
                    this.props.settings.enable_force_gift_name_number &&
                    (!this.state.name || !this.state.gift_recipient_number)
                  ) {
                    if (!this.state.name) {
                      this.setState({ errorName: true });
                    }
                    if (!this.state.gift_recipient_number) {
                      this.setState({ errorNumber: true });
                    }
                  } else {
                    this.props.SetGiftMsg(
                      this.state.name,
                      this.state.message,
                      this.state.gift_recipient_number,
                      this.state.gift_link,
                      this.state.giftAnonymousCheck,
                      this.state.call_recipient_check,
                      this.state.gift_wrapping
                    );
                    if (
                      !this.state.name &&
                      !this.state.message &&
                      !this.state.gift_recipient_number &&
                      !this.state.gift_link
                    ) {
                      this.props.SetGift(false);
                      this.setState({ Switch: false });
                    }
                  }
                }}
                clearGift={this.clearGift}
                handleChange={this.handleChange}
                errorName={this.state.errorName}
                errorNumber={this.state.errorNumber}
                name={this.props.name}
                message={this.props.message}
                gift_recipient_number={this.props.gift_recipient_number}
                gift_link={this.props.gift_link}
                call_recipient_check={this.state.call_recipient_check}
                giftAnonymousCheck={this.state.giftAnonymousCheck}
                unknownLocation={this.state.unknownLocation}
                gift_wrapping={this.state.gift_wrapping}
                toggleGiftAnonymous={this.toggleGiftAnonymous}
                toggleCallRecipient={this.toggleCallRecipient}
                toggleGiftWrapping={this.toggleGiftWrapping}
                urlPathname={this.props.urlPathname}
              />
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    cart: state.cart,
    promise: state.promise,
    themeColor: state.store.store.settings.dark || "#0099cc",
    address: state.customers?.address,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    enableIsGift: (value) =>
      dispatch({ type: "ENABLE_IS_GIFT", payload: value }),
    setGiftUnknownLocation: (value) =>
      dispatch({
        type: "SET_UNKNOWN_LOCATION",
        payload: value,
      }),
    resetAddress: () =>
      dispatch({ type: "RESET_ADDRESS_FOR_UNKNOWN_GIFT_LOCATION" }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Gift);
